// Protection légère du contenu : pas de clic droit, pas de glisser des images, pas de menu
// « Enregistrer l'image » à l'appui long, et raccourcis des outils de développement bloqués.
// Dissuasif seulement : un navigateur ne peut pas empêcher totalement la copie ni la console.
// Désactivé dans l'éditeur de thème Shopify.
(function () {
  if (window.Shopify && window.Shopify.designMode) return;

  document.addEventListener('contextmenu', (event) => event.preventDefault());

  document.addEventListener('dragstart', (event) => {
    if (event.target.closest && event.target.closest('img, video, picture')) event.preventDefault();
  });

  document.addEventListener('keydown', (event) => {
    // event.code (touche physique) : sur Mac, Cmd + Option + I donne event.key « ˆ » et non « i »
    const code = event.code || '';
    const touche = code.startsWith('Key') ? code.slice(3).toLowerCase() : (event.key || '').toLowerCase();
    const ctrl = event.ctrlKey || event.metaKey;
    const bloque =
      touche === 'f12' || code === 'F12' ||
      (ctrl && event.shiftKey && ['i', 'j', 'c'].includes(touche)) ||
      (ctrl && event.altKey && ['i', 'j', 'c'].includes(touche)) ||
      (ctrl && touche === 'u') ||
      (ctrl && touche === 's');
    if (bloque) {
      event.preventDefault();
      event.stopPropagation();
    }
  }, true);
})();
